import Api from "../apiService";

class expenseCategoriesApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/expense_categories`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, categoryId) {
    return Api.getRequest(
      `companies/${companyId}/expense_categories/${categoryId}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, categoryData) {
    return Api.postRequest(
      `companies/${companyId}/expense_categories`,
      categoryData,
      Api.authHeaders()
    );
  }

  update(companyId, categoryId, categoryData) {
    return Api.patchRequest(
      `companies/${companyId}/expense_categories/${categoryId}`,
      categoryData,
      Api.authHeaders()
    );
  }

  toggle(companyId, categoryId) {
    return Api.postRequest(
      `companies/${companyId}/expense_categories/${categoryId}/toggle`,
      Api.authHeaders()
    );
  }
}

export default new expenseCategoriesApi();
